export default __webpack_public_path__ + "static/media/chevron_down.f422c14e.svg";